import React from "react";
import StyledDiv from "../../../StyledDiv/StyledDiv";
import SectionContainer from "../../../../Core/SectionContainer/SectionContainer";
import Typography from "../../../../Foundation/Typography/Typography";
import FlexBox from "../../../FlexBox/FlexBox";
import htmlParse from "html-react-parser";
import { adrienCachotImages } from "../../../../Assets/images/adrien-cachot";
import useOnScreen from "../../../../Hooks/useOnScreen";

interface ILandingAboutAdrienCachotProps {
  title: string;
  description?: string;
}
const LandingAboutAdrienCachot = (props: ILandingAboutAdrienCachotProps) => {
  const { title, description } = props;
  const [containerRef, isOnScreen] = useOnScreen<HTMLDivElement>(
    { root: null, rootMargin: "200px 0px", threshold: 0 },
    { ignoreReverse: true }
  );
  return (
    <StyledDiv ref={containerRef} className="landing-about-adrien-cachot">
      <StyledDiv
        as={SectionContainer}
        styles={{
          minHeight: "843px",
          backgroundImage: isOnScreen
            ? `url(${adrienCachotImages.bgChef})`
            : "",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          mobile: {
            backgroundImage: isOnScreen
              ? `url(${adrienCachotImages.bgChefMobile})`
              : "",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            alignItems: "flex-start",
          },
        }}
      >
        <StyledDiv
          as={FlexBox}
          direction="column"
          gap={16}
          styles={{
            marginLeft: 140,
            paddingLeft: 40,
            maxWidth: 320,
            mobile: {
              marginLeft: 0,
              paddingTop: "116%",
              maxWidth: "100%",
            },
          }}
        >
          <Typography variant="adriencachotBig2" align="right">
            {title}
          </Typography>
          <Typography
            variant="adriencachotBody2"
            align="right"
            style={{
              letterSpacing: "-0.32px",
            }}
          >
            {description && htmlParse(description)}
          </Typography>
        </StyledDiv>
      </StyledDiv>
    </StyledDiv>
  );
};

export default LandingAboutAdrienCachot;
